import { useEffect } from 'react';
import { useSelector } from 'react-redux';

/**
 * @param {antd.FormInstance} form
 */

const useValidateFormOnLocaleChange = form => {
  const locale = useSelector(state => state.settings.locale);

  useEffect(() => {
    const fieldsWithErrors = form
      .getFieldsError()
      .filter(fieldError => !!fieldError.errors.length)
      .map(fieldError => fieldError.name);

    setTimeout(() => {
      form.validateFields(fieldsWithErrors);
    }, 0); // Ensure that the form validation is only triggered after the locale is updated.
  }, [locale, form]);
};

export default useValidateFormOnLocaleChange;
